export default __webpack_public_path__ + "static/media/Company News.a559bed6.svg";